/**
 * HasVideo.
 */
export const hasVideo = () => {
  /**
   * // TODO: maps to osmosis/app/featuredPlaylist.hasVideo
   * https://elsevier.atlassian.net/browse/OSMS-316.
   */
};

/**
 * MapToVideo.
 */
export const mapToVideo = () => {
  /**
   * TODO: maps to osmosis/app/featuredPlaylist.mapToVideo
   * https://elsevier.atlassian.net/browse/OSMS-316.
   */
  //
};

/**
 * QuickParse.
 */
export const quickParse = () => {
  /**
   * TODO: maps to osmosis/app/featuredPlaylist.quickParse
   * https://elsevier.atlassian.net/browse/OSMS-316.
   */
};

/**
 * GetPlaylistDuration.
 */
export const getPlaylistDuration = (secDur: number) => {
  const h = Math.floor(secDur / 3600);
  const m = Math.floor((secDur % 3600) / 60);
  const s = Math.round(secDur % 60);
  return [h, m > 9 ? m : h ? '0' + m : m || '0', s > 9 ? s : '0' + s]
    .filter(Boolean)
    .join(':');
};

/**
 * FormatePlaylistDurations.
 */
export const formatePlaylistDurations = (durations: string[]) => {
  if (durations.length) {
    const formattedDurations = durations.map((dur) => {
      const splittedTime = dur.split(':');
      if (splittedTime.length === 1) {
        return +splittedTime[0];
      } else if (splittedTime.length === 2) {
        const [minutes, seconds] = splittedTime;
        return +minutes * 60 + +seconds;
      } else if (splittedTime.length === 3) {
        const [hours, minutes, seconds] = splittedTime;
        return +hours * 3600 + +minutes * 60 + +seconds;
      } else {
        return 0;
      }
    });
    return formattedDurations.reduce((acc, dur) => acc + dur, 0);
  } else {
    return 0;
  }
};

/**
 * GetPlaylistPayloadWithNodes.
 */
export const getPlaylistPayloadWithNodes = (nodeIds: number[]) => {
  const isNodesMany = nodeIds.length > 1;
  return {
    [isNodesMany ? 'videos' : 'video']: isNodesMany
      ? nodeIds.map((id) => id.toString())
      : nodeIds[0].toString(),
  };
};
